import React from 'react'
import classes from './layout.css'

const SingleInput = (props) => (
	<span>
		<input
			defaultValue={props.value}
			name={props.name}
			type={props.inputType}
			placeholder={props.placeholder}
			className={classes.FormInputField}
			id={props.id}
			onChange={(e) => props.controlFunc(e.target.name, e.target.value, e.target.id)}
		/>
	</span>
)

export default SingleInput


// WEBPACK FOOTER //
// ./src/components/Fields/SingleInput.js